// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1ba6a498","667":"5f2388c2","977":"f04110ea"}[chunkId] + ".chunk.js";
};